import { Box, Icon, Typography } from '@material-ui/core'
import { useMobileReturnStyles } from './styles'
import { translate } from '../../utils/translation'

const MobileReturn = ({ className = '', onClick, page }) => {
  const styles = useMobileReturnStyles()
  let translatedPage = translate(page)
  return (
    <Box
      onClick={onClick && onClick}
      className={`${styles.container} ${className}`}>
      {onClick && <Icon className={styles.icon}>chevron_left</Icon>}
      <Typography className={styles.title}>{translatedPage}</Typography>
    </Box>
  )
}

export default MobileReturn
